export function updateRegistrationData(newData: Partial<any>) {
    const existingData = JSON.parse(localStorage.getItem("ngl-registration-data") || "{}");
    const updatedData = { ...existingData, ...newData };
    localStorage.setItem("ngl-registration-data", JSON.stringify(updatedData));
  }
  